var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-item"},[_c('div',{class:['status-item__icon', _vm.statusColor]},[_c('i',{class:_vm.statusIcon})]),_c('span',{staticClass:"status-item__title"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }